import React from "react";
import { Timer } from "./Paywall";

const ComparisonItem = ({ title, image, items, isPositive }) => {
  const IconComponent = isPositive ? CheckIcon : CrossIcon;
  const colorClass = isPositive ? "text-green-500" : "text-red-500";

  return (
    <div className="space-y-4">
      <img
        src={image}
        alt={title}
        className="w-full h-70 object-cover rounded-lg"
      />
      <div>
        <h4 className="font-bold text-gray-700 mb-3">{title}</h4>
        <ul className="space-y-2 text-sm">
          {items.map((item, index) => (
            <li key={index} className={`flex items-center ${colorClass}`}>
              <IconComponent />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const CheckIcon = () => (
  <svg
    className="w-5 h-5 mr-2 flex-shrink-0"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

const CrossIcon = () => (
  <svg
    className="w-5 h-5 mr-2 flex-shrink-0"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

const comparisonData = {
  restrictive: {
    title: "Restrictive diets:",
    image: "/w-restrictive-diets.png",
    items: ["limited choice of foods", "gain weight back"],
    isPositive: false,
  },
  ourPlan: {
    title: "Our plan:",
    image: "/w-our-plan.png",
    items: ["learn to make healthy choices", "keep the weight off"],
    isPositive: true,
  },
};

export function DietComparison() {
  return (
    <div className="mt-6 bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 text-white text-center">
        <h3 className="text-xl font-bold mb-2">
          Get real results that last and let AI do the work
        </h3>
        <div className="bg-green-700 py-2 rounded-full">
          <span className="font-bold mr-2">-41% DISCOUNT RESERVED FOR</span>
          <Timer />
        </div>
      </div>

      <div className="p-6">
        <div className="grid grid-cols-2 gap-6">
          <ComparisonItem {...comparisonData.restrictive} />
          <ComparisonItem {...comparisonData.ourPlan} />
        </div>
      </div>
    </div>
  );
}
